export enum PatchFilterEnum {
    ALL = 'ALL',
    REG = 'REG',
    MET = 'MET',
    INT = 'INT'
  }